import { validateTextWithHypen, injectSeparatorDateString, addDividerToMultipleTextField, formatDate, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import { userStatusOptionList } from '@/constants/userManagement';
import { userLevelCode } from '@/constants/userLevel';
import { formatPhoneNumber } from '@/utils/regularExpression';
export default class User {
    // 기존 IUser
    _code;
    _distributorId;
    _name;
    _headYn;
    _phone;
    _longitude;
    _latitude;
    _addChargeApplyYn;
    _addCookingTime;
    _addDeliveryCharge;
    _deliveryWorkYn;
    _addDeliveryChargeRate;
    _workerBulletin;
    _distributorDTO;
    _memo;
    _resignationAt;
    _level;
    _createdAt;
    _telephone;
    _hubName;
    _hubId;
    _userId;
    _useYn;
    _hubDTO;
    _distName;
    _storeName;
    constructor({ code, distributorId, name, headYn, phone, longitude, latitude, addChargeApplyYn, addCookingTime, addDeliveryCharge, deliveryWorkYn, addDeliveryChargeRate, workerBulletin, distributorDTO, memo, level, resignationAt, createdAt, telephone, hubName, hubId, useYn, userId, hubDTO, }) {
        this._code = code;
        this._distributorId = distributorId;
        this._name = name;
        this._headYn = headYn;
        this._phone = phone;
        this._longitude = longitude;
        this._latitude = latitude;
        this._addChargeApplyYn = addChargeApplyYn;
        this._addCookingTime = addCookingTime;
        this._addDeliveryCharge = addDeliveryCharge;
        this._deliveryWorkYn = deliveryWorkYn;
        this._addDeliveryChargeRate = addDeliveryChargeRate;
        this._workerBulletin = workerBulletin;
        this._distributorDTO = distributorDTO;
        this._memo = memo;
        this._resignationAt = resignationAt;
        this._level = level;
        this._name = name;
        this._telephone = telephone;
        this._createdAt = createdAt;
        this._hubName = hubName;
        this._hubId = hubId;
        this._userId = userId;
        this._useYn = useYn;
        this._hubDTO = hubDTO;
    }
    get code() {
        return this._code;
    }
    get distributorId() {
        return this._distributorId;
    }
    get headYn() {
        return this._headYn;
    }
    get phone() {
        return this._phone;
    }
    get useYn() {
        return this._useYn;
    }
    get longitude() {
        return this._longitude;
    }
    get latitude() {
        return this._latitude;
    }
    get addDeliveryCharge() {
        return this._addDeliveryCharge;
    }
    get deliveryWorkYn() {
        return this._deliveryWorkYn;
    }
    get workerBulletin() {
        return this._workerBulletin;
    }
    get addChargeApplyYn() {
        return this._addChargeApplyYn;
    }
    get addCookingTime() {
        return this._addCookingTime;
    }
    get addDeliveryChargeRate() {
        return this._addDeliveryChargeRate;
    }
    get distributorDTO() {
        return this._distributorDTO;
    }
    get formattedUseYn() {
        const formatted = userStatusOptionList.find((data) => data.value === this._useYn);
        return formatted?.text;
    }
    get userId() {
        return this._userId;
    }
    get validatedUserId() {
        return validateTextWithHypen(this.userId);
    }
    get distName() {
        return this._distName;
    }
    get validatedDistName() {
        return validateTextWithHypen(this.distName);
    }
    get hubId() {
        return this._hubId;
    }
    get hubName() {
        return this._hubName ?? this._hubDTO?.name;
    }
    get validatedHubName() {
        return validateTextWithHypen(this.hubName);
    }
    get formattedHubName() {
        return addDividerToMultipleTextField([
            this.hubName,
            this.hubId,
        ]);
    }
    get storeName() {
        return this._storeName;
    }
    get validatedStoreName() {
        return validateTextWithHypen(this.storeName);
    }
    get level() {
        return this._level;
    }
    get validatedLevel() {
        return validateTextWithHypen(this.level);
    }
    get formattedLevel() {
        return validateTextWithHypen(userLevelCode[this.level]?.text);
    }
    get name() {
        return this._name;
    }
    // 사용자명
    get validatedName() {
        return validateTextWithHypen(this.name);
    }
    get telephone() {
        return this._telephone;
    }
    get formattedTelephone() {
        return validateTextWithHypen(formatPhoneNumber(this.telephone));
    }
    get createdAt() {
        return this._createdAt;
    }
    get formattedCreatedAt() {
        return formatDate(this._createdAt, dateFormatType.DATE);
    }
    get resignationAt() {
        return this._resignationAt;
    }
    get formattedResignationAt() {
        return validateTextWithHypen(injectSeparatorDateString(this.resignationAt));
    }
    get memo() {
        return this._memo;
    }
    get validatedMemo() {
        return validateTextWithHypen(this.memo);
    }
}
